export interface IMessageService {
    subscribe<T>(name: string, subscriber: (event: any, message: T) => void): () => void;
    publish<T>(name: string, message: T): void;
}

export class MessageService implements IMessageService{

    static $inject: string[] = ['$rootScope'];

    constructor(private _$rootScope) {
        
    }

    public subscribe<T>(name: string, subscriber: (event: any, message: T) => void): () => void {
        return this._$rootScope.$on(name, subscriber);
    }

    public publish<T>(name: string, message: T): void {
        this._$rootScope.$broadcast(name, message);
    }
}

angular.module('deliveryCreate.app').service('MessageService', MessageService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/messageService.ts
 **/